import React,{Component} from 'react';
import BCA from '../../../images/bca.png';
import cashlez from '../../../images/cashlez.png';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AuthHelper from '../../../libraries/auth-helper';
import {history} from '../../../shared/configure-store';
import {toast, ToastContainer} from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import NumberFormat from 'react-number-format';
import language from '../../../libraries/label-lang';
import {bindActionCreators} from 'redux';
import {RootActions} from '../../../shared/root-action';
import {connect} from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import templateId from "../../../libraries/lang-id";
import Storage from "../../../libraries/storage";
import _ from 'lodash';

SimpleReactValidator.addLocale('indo', templateId);

class Topup extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            amount: '',
            amountOther: '',

            fetchStatus: false,
            cashlezStatus: '',

            loadingFetch: false,
            showPayment: false,
        };

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

    }

    componentDidMount(){

        document.title = 'Fresh Factory - Topup';
    };

    handleChange (e, prop){

        this.setState({
            amount: '',
            [prop]: e.target.value

        })

    };

    handleGo  = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleAmount  = (e, amount) => {
        e.preventDefault();

        this.setState({
            amountOther: '',
            amount: amount,
        })
    };

    handlePayment  = (e, amount) => {
        e.preventDefault();

    };

    handleSubmit = (e) => {

        e.preventDefault();

        /*if(this.state.amountOther !== '' && parseFloat(this.state.amountOther) < 100000) {
            this.setState({
                    errors: {
                        amountOther : 'Topup minimal Rp 100,000'
                    }
                }
            );

            return false;

        }*/

        this.setState({
                errors: {},
                loadingButton: true,
                showPayment: true,
            }
        );

        let params = {
            amount: this.state.amountOther !== '' ? this.state.amountOther : this.state.amount,
        };

        Api.post('/wallets/top_up', params, false).then(resp => {

            if(resp.data) {
                let data = Storage.get('payment');

                if(data === null) {
                    data = [];
                    data.push(resp.data)
                }else {
                    data.push(resp.data)
                }

                AuthHelper.setPayment(data);

                this.setState({
                        loadingButton: false,
                        referenceId: resp.data.referenceId,
                    });

                window.open(resp.data.generatedUrl, "_blank");
                this.__fetchPayment(resp.data.generatedUrl);

                this.interval = setInterval(() => {
                    if(this.state.cashlezStatus === 'CREATED' || this.state.cashlezStatus === 'PENDING') {
                        if(!this.state.loadingFetch){
                            this.__fetchPayment(resp.data.generatedUrl);
                        }
                    }else {
                        clearInterval(this.interval);
                    }
                }, 5000);

            }else {
                this.showMessage(true, 'Terjadi kesalahan. Silahkan lakukan kembali');

            }


        }).catch(err => {

            this.setState({
                    errors: err.errors,
                    loadingButton: false
                }
            );

            this.showMessage(false, 'Invalid format data');
        });


    };

    __fetchPayment = (link) => {

        this.setState({
            loadingFetch: true,
        });

        let params = {
            "status": "",
            "message": "",
            "data": {
                "request": {
                    "generatedUrl": link
                }
            }
        };

        Api.post('https://api-link.cashlez.com/validate_url', params, false).then(resp => {

            if (resp.data) {
                let respon = resp.data.response;

                this.setState({
                        loadingFetch: false,
                        loadingButton: false,
                        cashlezStatus: respon.processStatus,
                        fetchStatus: respon.status === 'INVALID',
                    }
                );

                if(respon.processStatus === 'APPROVED') {
                    this.__paymentSuccess();
                }

                if(respon.processStatus === 'REJECTED') {
                    this.__paymentFailed();
                }
            }


        }).catch(err => {

            this.setState({
                    loadingFetch: false,
                    errors: err.errors,
                    loadingButton: false
                }
            );

            this.showMessage(false, 'Invalid format data');
        });

    };

    __paymentFailed = () => {
        let params = {
            reference_id: this.state.referenceId,
        };

        Api.put('/wallets/failed/top_up', params).then(resp => {

            this.__removeItem(this.state.referenceId);
            this.showMessage(false, 'Topup Gagal');
        }).catch(err => {

            this.setState({
                cashlezStatus: 'REJECTED',
                }
            );
        });

    };

    __paymentSuccess = () => {
        let params = {
            reference_id: this.state.referenceId,
        };

        Api.put('/wallets/success/top_up', params).then(resp => {

            this.__removeItem(this.state.referenceId);
            this.showMessage(true, 'Topup Berhasil');
        }).catch(err => {

            this.setState({
                    cashlezStatus: 'REJECTED',
                }
            );
        });

    };

    __removeItem = (id) => {
        let payment = AuthHelper.getPayment();

        _.remove(payment, {
            referenceId: id
        });

        AuthHelper.setPayment(payment);
    };

    modalClose = () => {
        this.setState({
            showPayment: false,
            }
        );
    };

    NumberFormatCustom = (props) => {
        const { inputRef, onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                fixedDecimalScale={false}
                thousandSeparator
                isNumericString
            />
        );
    };


    render() {
        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item'><Link to='/histories' >{text.label_history}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>Top Up</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>Top Up</h2>

                <div className='row'>
                    <div className='col-lg-8'>
                        <form className='card-white__dash mb-3'>
                            <div className='card-header'>
                                <h3 className='mb-0'>Nominal</h3>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-6 col-md-3'>
                                    <button className={this.state.amount === '100000' ? 'check-option active' : 'check-option'} onClick={(e) => this.handleAmount(e, '100000')}>Rp 100,000</button>
                                </div>
                                <div className='col-6 col-md-3'>
                                    <button className={this.state.amount === '300000' ? 'check-option active' : 'check-option'} onClick={(e) => this.handleAmount(e, '300000')}>Rp 300,000</button>
                                </div>
                                <div className='col-6 col-md-3'>
                                    <button className={this.state.amount === '500000' ? 'check-option active' : 'check-option'} onClick={(e) => this.handleAmount(e, '500000')}>Rp 500,000</button>
                                </div>
                                <div className='col-6 col-md-3'>
                                    <button className={this.state.amount === '1000000' ? 'check-option active' : 'check-option'} onClick={(e) => this.handleAmount(e, '1000000')}>Rp 1,000,000</button>
                                </div>
                            </div>
                            <p>Pembelian Topup Manual Minimal <br />
                                Rp 100,000</p>
                            <div className='row mb-3'>
                                <div className='col-6 col-md-4'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='amountOther'
                                            name='amountOther'
                                            label='Masukkan Nominal'
                                            onChange={(e) => this.handleChange(e, 'amountOther')}
                                            value={this.state.amountOther}
                                            InputProps={{
                                                inputComponent: this.NumberFormatCustom,
                                            }}
                                            fullWidth
                                        />
                                        <div className='text-danger'>{this.state.errors.amountOther}</div>

                                    </div>
                                </div>
                            </div>

                            <div className='card-header'>
                                <h3 className='mb-0'>Metode Pembayaran</h3>
                            </div>
                            <div className='row mb-3'>
                                {/*<div className='col-6 col-md-4'>
                                    <button className='check-option' onClick={(e) => this.handlePayment(e, 'bca')}>
                                        <small>Transfer Bank</small>
                                        <img src={BCA} />
                                    </button>
                                </div>*/}
                                <div className='col-6 col-md-4'>
                                    <button className='check-option' onClick={(e) => this.handlePayment(e, 'bca')}>
                                        <small>Pembayaran Instan</small>
                                        <img src={cashlez} />
                                    </button>
                                </div>
                            </div>
                        </form>

                        <div className='card-white__dash mb-3'>
                            <div className='row align-items-center'>
                                <div className='col-md-6'>
                                    <p className='mb-0'>Total Pembayaran</p>
                                    <h3 className='number mb-0 color-dark-sky-blue'>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.amountOther !== '' ? this.state.amountOther : this.state.amount} fixedDecimalScale={false} displayType={'text'} renderText={value => value}/></h3>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={this.handleSubmit}
                                    >
                                        Bayar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    this.state.showPayment &&
                    <div className='modal-payment'>
                        <div className='container text-center'>
                            <h3>Menghubungkan Cashlez</h3>

                            {(this.state.cashlezStatus === '' ||
                            this.state.cashlezStatus === 'CREATED') &&
                                <>
                                    <p>Proses menunggu pembayaran</p>
                                    <i className='fa fa-spinner fa-spin'> </i>
                                </>
                            }

                            {this.state.cashlezStatus === 'PENDING' &&
                                <>
                                    <p>Pembayaran sedang diproses</p>
                                    <i className='fa fa-spinner fa-spin'> </i>
                                </>
                            }

                            {this.state.cashlezStatus === 'REJECTED' &&
                                <>
                                    <p>Pembayaran gagal</p>
                                    <i className="fas fa-times-circle red"> </i>
                                </>
                            }
                            {this.state.cashlezStatus === 'APPROVED' &&
                                <>
                                    <p>Pembayaran berhasil</p>
                                    <i className="fas fa-check-circle green"> </i>
                                </>
                            }

                            {(this.state.cashlezStatus === 'REJECTED' ||
                                this.state.cashlezStatus === 'APPROVED') &&
                                <div className='text-center mt-3'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={this.modalClose}
                                    >
                                        Kembali
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                }

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Topup));